<template xmlns:v-on="http://www.w3.org/1999/xhtml" xmlns="http://www.w3.org/1999/html">
  <div class="video-player">
    <div class="video-player-div" @click="playOrPause" tabindex="0">
      <video-player
        ref="videoPlayer"
        :options="playerOptions"
        :playsinline="true"
        @loadeddata="onLoader"
        @timeupdate="onPlayerTimeupdate($event)"
        @playing="onPlayerPlaying($event)"
        @ended="onPlayerEnded($event)"
        @error="onError($event)"
      ></video-player>
      <div
        :class="[!isMin ? 'large-play-icon' : 'large-play-icon1']"
        v-if="!started && isMin"
      ></div>
      <div class="close" @click.stop="close" v-if="isMin">
        <img src="/static/video/video_miniplayer_close_btn.png" alt />
      </div>
      <!-- 播放推荐 -->
      <div
        class="recommendBox"
        @click.stop
        v-if="isEnd && !autoplay && !isMin && !isRecommend"
      >
        <div class="recommendMana">
          <p class="headTitle">{{ $t("video.为您推荐") }}</p>
          <ul>
            <li
              v-for="(item, i) in vedioList.slice(0, 3)"
              :key="i"
              @click="nextVideo(item.videoId)"
            >
              <img :src="item.thumb | imageUrl('', 384, 216)" alt />
              <div class="information">
                <p class="title">{{ item.title }}</p>
                <p class="name">{{ item.userNickName }}</p>
                <p class="time">{{ formatTime(item.duration) }}</p>
              </div>
            </li>
          </ul>
          <div class="recommendShare share">
            <p>{{ $t("global.分享") }}</p>
            <share :config="config" :type="1"></share>
          </div>
        </div>
      </div>
      <div v-if="isEnd && autoplay && !isMin">
        <div
          class="nextOpenVideoBox"
          v-for="(item, i) in relatedVedioList.slice(0, 1)"
          :key="i"
        >
          <div class="nextOpenVideo">
            <p class="headTitle">{{ $t("video.接下来播放") }}:</p>
            <div class="buttonTime" @click="nextVideo(item.videoId)">
              <img
                class="thumbImg"
                :src="item.thumb | imageUrl('', 510, 286)"
                alt
              />
              <el-progress
                class="countDown"
                type="circle"
                :percentage="percentage"
                :stroke-width="3"
                :width="70"
                :show-text="false"
                color="#ffffff"
              ></el-progress>
              <img
                class="buttonImg"
                src="/static/video/icon_video_autoplay_next@2x.png"
                alt
              />
            </div>
            <p class="title">{{ item.title }}</p>
            <p class="name">{{ item.userNickName }}</p>
          </div>
        </div>
      </div>
    </div>
    <!-- 提示静音 -->
    <div class="muteBox" v-if="isShowMute">
      <img @click="isShowMute=false" src="https://image.manamana.net/1656051686000_elkrsIxu" alt=""><i>{{ $t("video.已静音播放") }}</i><span @click="hideMute">{{ $t("video.点击恢复音量") }}</span>
    </div>
    <!-- 底部进度条 start -->
    <div class="player-controller hideDelay">
      <div class="process-bar">
        <div
          class="thumbnail"
          v-if="isShow && src"
          :style="'left:' + offsetX + '%'"
        >
          <img :src="src" alt />
          <span class="hoverTime">{{ hoverTime }}</span>
        </div>
        <div
          class="loading-bar"
          :style="'width:' + bufferedPercent + '%'"
        ></div>
        <el-slider
          v-model="playPercent"
          class="playing-bar"
          :step="0.1"
          @change="setPlayPercent"
          :format-tooltip="formatPlayPercent"
          :show-tooltip="false"
        ></el-slider>
      </div>
      <!-- <div class="process-bar-bg" @mousemove="isShowPhoto" @mouseout="isHidePhoto"></div> -->
      <div class="play-info">
        <span
          class="play-btn"
          @click="playOrPause"
          v-if="!isPlaying && !isEnd"
        ></span>
        <span
          class="play-pause-btn"
          @click="playOrPause"
          v-if="isPlaying && !isEnd"
        ></span>
        <span class="play-pause-end" @click="playOrPause" v-if="isEnd"></span>
        <div class="play-right">
          <span class="play-time" v-if="!isMin">
            <i>{{ currentTimeFormat }}</i>
            / {{ totalTimeFormat }}
          </span>
          <span class="play-volume" v-if="!isMin">
            <span
              class="play-volume-icon"
              v-if="!currentmute"
              @click="mute(true)"
            ></span>
            <span
              class="play-volume-icon play-volume-icon-mute"
              v-if="currentmute"
              @click="mute(false)"
            ></span>
            <ul class="play-volume-list">
              <el-slider
                class="volume"
                v-model="volume"
                height="70px"
                :show-tooltip="false"
                vertical
                @change="setVolume"
              ></el-slider>
              <!-- <li @click="setVolume(0.1)" :class="{active:volume>=0.1}">
                <div></div>
              </li>
              <li @click="setVolume(0.2)" :class="{active:volume>=0.2}">
                <div></div>
              </li>
              <li @click="setVolume(0.3)" :class="{active:volume>=0.3}">
                <div></div>
              </li>
              <li @click="setVolume(0.4)" :class="{active:volume>=0.4}">
                <div></div>
              </li>
              <li @click="setVolume(0.5)" :class="{active:volume>=0.5}">
                <div></div>
              </li>
              <li @click="setVolume(0.6)" :class="{active:volume>=0.6}">
                <div></div>
              </li>
              <li @click="setVolume(0.7)" :class="{active:volume>=0.7}">
                <div></div>
              </li>
              <li @click="setVolume(0.8)" :class="{active:volume>=0.8}">
                <div></div>
              </li>
              <li @click="setVolume(0.9)" :class="{active:volume>=0.9}">
                <div></div>
              </li>
              <li @click="setVolume(1)" :class="{active:volume>=1}">
                <div></div>
              </li>-->
            </ul>
          </span>
          <span class="play-select" v-if="!isMin">
            <i>{{ currentVideoSelected.replace("s", "") + "P" }}</i>
            <ul class="play-select-list">
              <li class="picture">{{ $t("video.画质") }}</li>
              <li
                v-if="
                  playerOptions.videoList && playerOptions.videoList['s1080']
                "
                @click="changeVideo('s1080')"
                :class="{ active: currentVideoSelected == 's1080' }"
              >
                <img
                  v-if="currentVideoSelected == 's1080'"
                  src="/static/video/video_quality_tick_blue.png"
                  alt
                />
                {{ $t("video.超高清") }} 1080P
              </li>
              <li
                v-if="
                  playerOptions.videoList && playerOptions.videoList['s720']
                "
                @click="changeVideo('s720')"
                :class="{ active: currentVideoSelected == 's720' }"
              >
                <img
                  v-if="currentVideoSelected == 's720'"
                  src="/static/video/video_quality_tick_blue.png"
                  alt
                />
                {{ $t("video.高清") }} 720P
              </li>
              <li
                v-if="
                  playerOptions.videoList && playerOptions.videoList['s480']
                "
                @click="changeVideo('s480')"
                :class="{ active: currentVideoSelected == 's480' }"
              >
                <img
                  v-if="currentVideoSelected == 's480'"
                  src="/static/video/video_quality_tick_blue.png"
                  alt
                />
                {{ $t("video.标清") }} 480P
              </li>
            </ul>
          </span>

          <span class="play-fullscreen" @click="fullscreen"></span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { videoPlayer } from "vue-video-player";
import "video.js/dist/video-js.css";
import comm from "@/assets/comm.js";
import { imageUrl } from "@/util/filters.js";
import Share from "@/components/v2/Share";

export default {
  name: "ManaPlayer",
  props: [
    "playerOptions",
    "videoId",
    "relatedVedioList",
    "recommendVedioList",
    "config",
    "isMin",
    "isRecommend",
    "lookId",
    "lookList"
  ],
  components: {
    videoPlayer,
    Share,
  },
  data() {
    return {
      autoplay: false,
      isPlay: false,
      playerCtrl: {},
      progressTipFormat: "",
      isBottomCtrlShow: true,
      started: false,
      currentTimeFormat: "00:00",
      totalTimeFormat: "00:00",
      currentTime: 0,
      totalTime: 0,
      playing: false,
      currentmute: false,
      playPercent: 0,
      bufferedPercent: 0,
      currentVideoSelected: "s1080",
      lastCurrentTime: 0,
      isFullscreen: false,
      timermouse: null,
      src: null,
      isShow: false,
      offsetX: 0,
      volume: 100,
      isEnd: false,
      isHover: false,
      vedioList: [],
      percentage: 0,
      dowmTime: 5,
      visible: false,
      timer: null,
      hoverTime: "",
      isPlaying: false,
      isShowMute: false
    };
  },
  created: function () {
    this.playerOptions.controls = false;
  },
  mounted: function () {
    var videoPlay = document.getElementsByClassName("video-player")[0];
    videoPlay.addEventListener("mousemove", this.opacityFun, false);
    videoPlay.addEventListener("mouseleave", this.opacityNone, false);
    this.$nextTick(() => {
      var a = document.getElementsByClassName("el-slider__runway")[0];
      a.addEventListener("mousemove", this.isShowPhoto, false);
      a.addEventListener("mouseout", this.isHidePhoto, false);
    });
    // if (this.relatedVedioList.length) {
    //   for (let i = 0; i < this.relatedVedioList.length; i++) {
    //     if (this.relatedVedioList[i].videoId == this.videoId) {
    //       this.relatedVedioList.splice(i, 1);
    //     }
    //   }
    // }
  },
  updated: function () {
    // console.log(this.playerOptions);
  },
  beforeDestroy() {
    if (this.isPlay || this.playing) {
      this.loggerPlay();
    }
  },
  watch: {
    isFullscreen(val) {},
    $route() {
      if (this.isPlay || this.playing) {
        this.loggerPlay();
      }
      this.isPlay = false;
      this.isEnd = false;
      this.percentage = 0;
      this.dowmTime = 5;
    },
    "playerOptions.autoplay"(value) {
      this.isEnd = false;
      if (value) {
        this.play();
      } else {
        this.pause();
      }
    }
  },
  destroyed: function () {
    document.removeEventListener("mousemove", this.opacityFun, false);
  },
  methods: {
    onError(e) {
      if(e.error_&& e.error_.code == 2) {
        this.player.load()
        this.playOrPause()
      }
    },
    //视频已开始播放回调
    onPlayerPlaying() {
      this.isPlaying = true;
      document
        .querySelector(".video-js")
        .classList.remove("vjs-waiting");
    },
    close() {
      this.$emit("min", false);
    },
    // 视频播完回调
    onPlayerEnded($event) {
      if (this.$query.lookId) {
        this.autoplay = true;
      } else {
        if (localStorage.getItem("isAutoPlay") != null) {
          if (localStorage.getItem("isAutoPlay") == 1) {
            this.autoplay = true;
          }
          if (localStorage.getItem("isAutoPlay") == 2) {
            this.autoplay = false;
          }
        }
        if (this.recommendVedioList && this.recommendVedioList.length > 3) {
          this.vedioList = this.recommendVedioList.slice(0, 3);
        }
        this.isEnd = true;
      }
      if (this.autoplay) {
        if (this.lookId) {
          this.$router.push(
            "/video/detail?id=" +
              this.lookList[0].id +
              "&lookId=" +
              this.lookId
          );
        } else {
          var timeSpan = 100,
            percentageSpan = timeSpan / this.dowmTime / 10;

          this.timer = setInterval(() => {
            this.dowmTime = this.dowmTime - timeSpan / 1000;
            this.percentage = this.percentage + percentageSpan;
            if (this.percentage > 100) {
              clearInterval(this.timer);
              if (this.$query.id == this.relatedVedioList[0].videoId) {
                this.$router.push(
                  "/video/detail?id=" + this.relatedVedioList[1].videoId
                );
              } else {
                this.$router.push(
                  "/video/detail?id=" + this.relatedVedioList[0].videoId
                );
              }
            }
          }, timeSpan);
        }
      }
    },
    nextVideo(id) {
      if (id) {
        clearInterval(this.timer);
        this.$router.push("/video/detail?id=" + id);
      }
    },
    isShowPhoto(e) {
      let width = document.getElementsByClassName("process-bar")[0].clientWidth;
      let time = (e.offsetX / width) * this.player.duration();
      var day = Math.floor(Math.round(time) / (24 * 3600));
      var hour = Math.floor((Math.round(time) - day * 24 * 3600) / 3600);
      var minute = Math.floor(
        (Math.round(time) - day * 24 * 3600 - hour * 3600) / 60
      );
      var second =
        Math.round(time) - day * 24 * 3600 - hour * 3600 - minute * 60;
      if (hour < 10) {
        hour = "0" + hour;
      }
      if (minute < 10) {
        minute = "0" + minute;
      }
      if (second < 10) {
        second = "0" + second;
      }
      if (hour <= 0) {
        this.hoverTime = minute + ":" + second;
      } else {
        this.hoverTime = hour + ":" + minute + ":" + second;
      }
      if (parseInt(Math.round(time) / 5) == 0) {
        time = 1;
      }
      time = parseInt(Math.round(time) / 5) * 5 + 1;
      if (time > (e.offsetX / width) * this.player.duration()) {
        time = parseInt((e.offsetX / width) * this.player.duration());
      }
      this.offsetX = ((e.offsetX - 70) / width) * 100;
      if (this.offsetX <= 0) {
        this.offsetX = 0;
      }
      if (this.offsetX >= 85) {
        this.offsetX = 85.5;
      }
      this.src = `${this.playerOptions.sources[0].src}?vframe/jpg/offset/${time}/w/140/h/78`;
      this.isShow = true;
    },
    isHidePhoto(e) {
      this.isShow = false;
      this.src = "";
    },
    loggerPlay() {
      const url = `/api/video/savePlayRecord`;
      const params = {
        videoId: this.videoId,
        source: 4,
        sourceUrl: `${window.location.origin}/video/detail?id=${this.videoId}#!${this.language}`,
      };
      this.$http.post(url, params).then((res) => {
        if (res.code === "OK") {
          // console.log(res.data);
        }
      });
    },
    opacityFun() {
      const elem = document.getElementsByClassName("hideDelay")[0];
      elem.style.opacity = 1;
      this.timermouse && clearTimeout(this.timermouse);
      this.timermouse = setTimeout(() => {
        const elem = document.getElementsByClassName("hideDelay")[0];
        elem.style.opacity = 0;
      }, 3000);
      var videoPlay = document.getElementsByClassName("video-player")[0];
      var timer;
      var hidding = false;
      if (hidding) {
        hidding = false;
        return;
      }
      if (timer) {
        clearTimeout(timer);
        timer = 0;
      }
      videoPlay.style.cursor = "auto";
      timer = setTimeout(function () {
        hidding = true;
        videoPlay.style.cursor = "none";
      }, 2000);
    },
    opacityNone() {
      const elem = document.getElementsByClassName("hideDelay")[0];
      elem.style.opacity = 0;
    },
    playOrPause() {
      this.isPlay = true;
      if (this.playing&&this.isPlaying) {
        this.player.pause();
        this.playing = false;
        this.started = false;
        this.isPlaying = false;
      } else {
        this.player.play();
        this.started = true;
        this.playing = true;
        this.isPlaying = true;
      }
      if (this.isEnd) {
        this.player.src();
        this.player.play();
        this.isEnd = false;
        this.started = true;
        this.playing = true;
        this.isPlaying = true;
      }
      // document.querySelector(".video-player-div").focus();
    },
    play() {
      this.player.play();
      this.started = true;
      this.playing = true;
    },
    pause() {
      this.player.pause();
      this.playing = false;
      this.started = false;
    },
    onPlayerTimeupdate(e) {
      this.currentTimeFormat = this.formatTime(this.player.currentTime());
      this.currentTime = this.player.currentTime();
      this.playPercent = (this.currentTime / this.totalTime) * 100;
      this.bufferedPercent = this.player.bufferedPercent() * 100;
    },
    onLoader() {
      this.player.muted(false);
      if (this.playerOptions.autoplay) {
        this.player.muted(false);
        this.started = true;
        this.playing = true;
      }
      if (this.playing) {
        this.player.play().then((suc)=>{
          this.isPlaying = true;
        },(error)=>{
          this.mute(true)
          this.isShowMute = true;
          setTimeout(()=>{
            this.isShowMute = false;
          },5000)
        });
      }
      this.player.src();
      this.player.play();
      this.totalTimeFormat = this.formatTime(this.player.duration());
      this.totalTime = this.player.duration();
      this.volume = this.player.volume() * 100;
      this.currentmute = this.player.muted();
      this.player.currentTime(this.lastCurrentTime);
      Object.keys(this.playerOptions.videoList).forEach((key) => {
        if (this.playerOptions.videoList[key] == this.player.currentSrc()) {
          this.currentVideoSelected = key;
        }
      });
    },
    setVolume(val) {
      // this.volume = val;
      this.player.volume(val / 100);
    },
    mute(val) {
      this.player.muted(val);
      this.currentmute = val;
      if (!val) {
        this.volume = 100;
      } else {
        this.volume = 0;
      }
    },
    hideMute() {
      this.mute(false);
      this.isShowMute = false;
    },
    setPlayPercent(val) {
      this.player.currentTime((val / 100) * this.totalTime);
      this.player.play();
      this.isEnd = false;
      this.started = true;
      this.playing = true;
    },
    fullscreen() {
      this.requestFullScreen(
        document.getElementsByClassName("video-player")[0]
      );
      document.querySelector(".video-player-div").focus();
    },
    formatPlayPercent(val) {
      let newtime = (val / 100) * this.totalTime;
      return this.formatTime(newtime) + "/" + this.formatTime(this.totalTime);
    },
    formatTime(val) {
      if (!val || isNaN(val) || val < 0) {
        return "00:00";
      }
      if (val < 60) {
        return "00:" + this.PrefixInteger(Math.floor(val), 2);
      }
      if (val < 3600) {
        let minuts = Math.floor(val / 60).toString();
        let seconds = Math.floor(val % 60).toString();
        return (
          this.PrefixInteger(minuts, 2) + ":" + this.PrefixInteger(seconds, 2)
        );
      }
      let hours = Math.floor(val / 3600).toString();
      let minuts = Math.floor((val % 3600) / 60).toString();
      let seconds = Math.floor(val % 60).toString();
      return (
        hours +
        ":" +
        this.PrefixInteger(minuts, 2) +
        ":" +
        this.PrefixInteger(seconds, 2)
      );
    },
    PrefixInteger(num, length) {
      return (Array(length).join("0") + num).slice(-length);
    },
    changeVideo(val) {
      this.lastCurrentTime = this.player.currentTime();
      this.player.src([
        { type: "video/mp4", src: this.playerOptions.videoList[val] },
      ]);
      this.currentVideoSelected = val;
    },
    requestFullScreen(element) {
      if (this.isFullscreen) {
        if (document.exitFullscreen) {
          document.exitFullscreen();
        } else if (document.mozCancelFullScreen) {
          document.mozCancelFullScreen();
        } else if (document.webkitCancelFullScreen) {
          document.webkitCancelFullScreen();
        } else if (document.msExitFullscreen) {
          document.msExitFullscreen();
        }
        if (typeof cfs != "undefined" && cfs) {
          cfs.call(el);
        } else {
          var el = document.documentElement;
          var rfs = el.msRequestFullScreen;
          if (typeof window.ActiveXObject != "undefined") {
            //这的方法模拟键，使浏览器全屏
            var wscript = new ActiveXObject("WScript.Shell");
            if (wscript != null) {
              wscript.SendKeys("{F11}");
            }
          }
        }
      } else {
        var requestMethod =
          element.requestFullScreen ||
          element.webkitRequestFullScreen ||
          element.mozRequestFullScreen ||
          element.msRequestFullScreen;
        if (requestMethod) {
          requestMethod.call(element);
        } else if (typeof window.ActiveXObject !== "undefined") {
          var wscript = new ActiveXObject("WScript.Shell");
          if (wscript !== null) {
            wscript.SendKeys("{F11}");
          }
        }
      }
      this.isFullscreen = !this.isFullscreen;
    },
    setHotKeys(e) {
      switch (e.which) {
        case 32:
          this.playOrPause();
          break;
        case 37:
          this.player.currentTime(this.player.currentTime() - 5);
          break;
        case 39:
          this.player.currentTime(this.player.currentTime() + 5);
          break;
        default:
          break;
      }
    },
  },
  computed: {
    player() {
      // setTimeout(() => {
      //   document
      //     .querySelector(".vjs-loading-spinner")
      //     .classList.add("vjs-hidden");
      // }, 3000);
      return this.$refs.videoPlayer.player;
    },
    language() {
      return this.$language();
    },
  },
};
</script>
<style>
/* .vjs-loading-spinner{
  display: none!important;
} */
.vjs-loading-spinner{display:none!important;}
.el-progress-circle__track {
  stroke: rgba(255, 255, 255, 0.2);
}
.video-player {
  position: relative;
}

.video-player,
.video-player-div,
.video-player .video-js {
  width: 100%;
  height: 100%;
  overflow: hidden;
}
.bdsharebuttonbox {
  display: inline-block;
  vertical-align: middle;
}
.video-player-div {
  position: relative;
}
.video-player-div .recommendBox {
  position: absolute;
  width: 100%;
  height: 100%;
  padding: 60px 77px;
  box-sizing: border-box;
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.8);
}
.video-player-div .recommendMana {
  position: absolute;
  width: 606px;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.close {
  position: absolute;
  width: 20px;
  height: 20px;
  right: 12px;
  top: 12px;
  cursor: pointer;
}
.close img {
  width: 100%;
  height: 100%;
}
.video-player-div .recommendMana .headTitle {
  font-size: 16px;
  font-weight: 500;
  color: rgba(184, 184, 184, 1);
  text-align: center;
  margin-bottom: 20px;
}
.video-player-div .recommendMana ul {
  width: 100%;
  height: 108px;
  margin-bottom: 48px;
}
.video-player-div .recommendMana ul li {
  width: 192px;
  height: 108px;
  margin-right: 15px;
  float: left;
  position: relative;
  cursor: pointer;
}
.video-player-div .recommendMana ul li img {
  width: 100%;
  height: 100%;
}
.video-player-div .recommendMana ul li .information {
  position: absolute;
  left: 0;
  top: 0;
  padding: 10px;
  width: 100%;
  height: 80px;
  background: linear-gradient(
    180deg,
    rgba(0, 0, 0, 0.8) 0%,
    rgba(0, 0, 0, 0.24) 29%,
    rgba(0, 0, 0, 0) 100%
  );
  box-sizing: border-box;
  display: none;
}
.video-player-div .recommendMana ul li:hover .information {
  display: block;
}
.video-player-div .recommendMana ul li .information .title {
  max-height: 32px;
  font-size: 12px;
  font-weight: 600;
  color: rgba(255, 255, 255, 1);
  line-height: 16px;
  text-align: left;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}
.video-player-div .recommendMana ul li .information .name {
  height: 16px;
  font-size: 10px;
  font-weight: 400;
  color: rgba(255, 255, 255, 1);
  line-height: 16px;
  text-align: left;
}
.video-player-div .recommendMana ul li .information .time {
  width: 40px;
  height: 18px;
  background: rgba(10, 10, 10, 0.6);
  text-align: center;
  line-height: 18px;
  font-size: 12px;
  font-weight: 400;
  color: rgba(255, 255, 255, 1);
  position: absolute;
  right: 5px;
  bottom: -26px;
}
.video-player-div .recommendMana ul li:nth-child(3) {
  margin-right: 0;
}
.nextOpenVideoBox {
  position: absolute;
  width: 100%;
  height: 100%;
  padding: 60px 155px;
  box-sizing: border-box;
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.8);
}
.nextOpenVideoBox .nextOpenVideo {
  width: 450px;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}
.nextOpenVideoBox .nextOpenVideo .title {
  width: 100%;
  font-size: 16px;
  font-weight: 600;
  color: rgba(255, 255, 255, 1);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  margin-bottom: 10px;
  text-align: center;
}
.nextOpenVideoBox .nextOpenVideo .name {
  font-size: 14px;
  font-weight: 400;
  color: rgba(255, 255, 255, 1);
  text-align: center;
}
.nextOpenVideoBox .nextOpenVideo .headTitle {
  font-size: 16px;
  font-weight: 400;
  color: rgba(184, 184, 184, 1);
  margin-bottom: 25px;
  text-align: center;
}
.nextOpenVideoBox .nextOpenVideo .buttonTime {
  width: 255px;
  height: 143px;
  position: relative;
  margin-left: 97px;
  margin-bottom: 15px;
  cursor: pointer;
}
.nextOpenVideoBox .nextOpenVideo .buttonTime img.thumbImg {
  display: inline-block;
  width: 100%;
  height: 100%;
}
.nextOpenVideoBox .nextOpenVideo .buttonTime img.buttonImg {
  position: absolute;
  width: 24px;
  height: 24px;
  left: 115.5px;
  top: 59.5px;
}
.nextOpenVideoBox .nextOpenVideo .buttonTime .countDown {
  position: absolute;
  left: 92px;
  top: 36px;
}
.recommendShare p {
  font-size: 16px;
  font-weight: 500;
  color: rgba(184, 184, 184, 1);
  text-align: center;
  margin-bottom: 20px;
}
.recommendShare .shareBox {
  width: 100%;
  text-align: center;
  height: 26px;
}
.recommendShare .shareBox a {
  display: inline-block;
  margin-right: 18px;
  cursor: pointer;
}
.top-bottom-icon.icon-weibo {
  background: url("/static/video/fin_share_weibo_hover@2x.png") no-repeat center
    center;
  background-size: contain;
  width: 26px;
  height: 26px;
}

.top-bottom-icon.icon-wechat {
  background: url("/static/video/fin_share_wechat_hover@2x.png") no-repeat
    center center;
  background-size: contain;
  width: 26px;
  height: 26px;
}

.top-bottom-icon.icon-qq {
  background: url("/static/video/fin_share_qq_hover@2x.png") no-repeat center
    center;
  background-size: contain;
  width: 26px;
  height: 26px;
}

.top-bottom-icon.icon-twi {
  background: url("/static/video/fin_share_twitter_hover@2x.png") no-repeat
    center center;
  background-size: contain;
  width: 26px;
  height: 26px;
}

.top-bottom-icon.icon-face {
  background: url("/static/video/fin_share_fb_hover@2x.png") no-repeat center
    center;
  background-size: contain;
  width: 26px;
  height: 26px;
}

.large-play-icon {
  position: absolute;
  display: block;
  width: 53px;
  height: 70px;
  background: url("/static/video/video_play_tri_70.png") no-repeat center center;
  background-size: cover;
  left: 50%;
  top: 50%;
  margin-left: -0.62rem;
  margin-top: -0.63rem;
  cursor: pointer;
}
.large-play-icon1 {
  position: absolute;
  display: block;
  width: 26px;
  height: 35px;
  background: url("/static/video/video_play_tri_70.png") no-repeat center center;
  background-size: cover;
  left: 60%;
  top: 60%;
  margin-left: -0.62rem;
  margin-top: -0.63rem;
  cursor: pointer;
}
.playing-bar .el-slider__button-wrapper {
  top: -7px;
  pointer-events: none;
}
.el-slider.is-vertical .el-slider__runway {
  width: 3px;
}
.el-slider.is-vertical .el-slider__bar {
  width: 3px;
}
.muteBox{
  position: absolute;
  left: 10px;
  bottom: 50px;
  padding: 0 20px 0 12px;
  line-height: 42px;
  height: 42px;
  background: rgba(51, 51, 51, 0.8);
  border-radius: 22px;
  font-size: 14px;
  font-weight: 400;
  color: #FFFFFF;
  cursor: pointer;
}
.muteBox img{
  width: 26px;
  height: 26px;
}
.muteBox span{
  font-size: 14px;
  font-weight: 500;
  color: #3664ED;
}
.muteBox i{
  margin: 0 10px 0 4px;
}
.player-controller {
  width: 100%;
  height: 40px;
  background: linear-gradient(
    180deg,
    rgba(0, 0, 0, 0) 0%,
    rgba(0, 0, 0, 0.4) 100%
  );
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 0 20px 0 16px;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
  opacity: 0;
  -webkit-transition: opacity 0.3s;
  -moz-transition: opacity 0.3s;
  -ms-transition: opacity 0.3s;
  -o-transition: opacity 0.3s;
  transition: opacity 0.3s;
}

.video-player:hover .player-controller {
  opacity: 1;
}

.player-controller .process-bar {
  position: absolute;
  height: 4px;
  top: -14px;
  left: 0;
  right: 0;
  /* padding: 10px 0; */
  cursor: pointer;
}
.process-bar-bg {
  position: absolute;
  top: -4px;
  right: 0;
  bottom: 10px;
  left: 0;
  height: 4px;
  /* z-index: 111; */
  background-color: rgba(255, 255, 255, 0);
  cursor: pointer;
}
.player-controller .process-bar .thumbnail {
  position: absolute;
  width: 144px;
  height: 82px;
  top: -80px;
  border: 2px solid rgba(0, 0, 0, 0.6);
  box-sizing: border-box;
}
.player-controller .process-bar .thumbnail img {
  width: 140px;
  height: 78px;
}
.player-controller .process-bar .thumbnail .hoverTime {
  position: absolute;
  display: inline-block;
  padding: 0 5px;
  height: 20px;
  line-height: 20px;
  text-align: center;
  background: rgba(0, 0, 0, 0.6);
  bottom: 1px;
  left: 50%;
  font-size: 12px;
  font-weight: 600;
  color: rgba(255, 255, 255, 1);
  transform: translateX(-50%);
}

.player-controller .loading-bar {
  position: absolute;
  height: 4px;
  top: 10px;
  left: 0;
  background-color: rgba(255, 255, 255, 0.6);
}

.player-controller .playing-bar {
  position: absolute;
  height: 4px;
  top: 10px;
  left: 0;
  width: 100%;
  background: rgba(255, 255, 255, 0.29);
}

.player-controller .playing-ball {
  display: block;
  width: 11px;
  height: 11px;
  background-color: #fff;
  -webkit-border-radius: 50%;
  -moz-border-radius: 50%;
  border-radius: 50%;
  position: absolute;
  right: -5px;
  top: -1px;
  cursor: pointer;
}

.play-info {
  font-size: 12px;
  color: #fff;
}

.play-info .play-btn {
  display: inline-block;
  width: 40px;
  height: 40px;
  background: url("/static/vedio/video_play_icon.png") no-repeat center center;
  -webkit-background-size: cover;
  background-size: cover;
  cursor: pointer;
  vertical-align: middle;
}

.play-info .play-pause-btn {
  display: inline-block;
  width: 40px;
  height: 40px;
  background: url("/static/vedio/video_pause_icon.png") no-repeat center center;
  -webkit-background-size: cover;
  background-size: cover;
  cursor: pointer;
  vertical-align: middle;
}

.play-info .play-pause-end {
  display: inline-block;
  width: 40px;
  height: 40px;
  background: url("/static/vedio/video_replay_icon.png") no-repeat center center;
  -webkit-background-size: cover;
  background-size: cover;
  cursor: pointer;
  vertical-align: middle;
}
.play-time {
  color: #fff;
  margin-left: 13px;
  vertical-align: middle;
  display: inline-block;
}

.play-time i {
  color: #fff;
}

.play-right {
  float: right;
  height: 20px;
  line-height: 20px;
  padding-top: 10px;
}

.play-select {
  position: relative;
  display: inline-block;
  cursor: pointer;
  width: 37px;
  height: 20px;
  text-align: center;
  vertical-align: middle;
  margin-left: 13px;
}

.play-select i {
  position: absolute;
  right: 0;
  left: 0;
}

.play-select-list {
  position: absolute;
  bottom: 20px;
  left: 50%;
  transform: translateX(-50%);
  background-color: rgba(0, 0, 0, 0.7);
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
  text-align: center;
  display: none;
  width: 110px;
  background: rgba(0, 0, 0, 0.5);
  padding-bottom: 5px;
}
.play-select-list .picture {
  height: 30px;
  line-height: 30px;
  width: 100%;
  text-align: center;
  padding: 0;
  font-size: 12px;
  font-weight: 400;
  color: rgba(184, 184, 184, 1);
  border-bottom: 1px solid rgba(255, 255, 255, 0.2);
}
.play-select:hover .play-select-list {
  display: block;
}

.play-select-list li {
  height: 28px;
  line-height: 28px;
  font-size: 12px;
  color: rgba(255, 255, 255, 1);
  text-align: left;
  cursor: pointer;
  position: relative;
  padding-left: 25px;
  box-sizing: border-box;
}
.play-select-list li img {
  position: absolute;
  width: 10px;
  height: 9px;
  vertical-align: middle;
  left: 5px;
  top: 10px;
}

.play-select-list li.active {
  font-weight: 600;
}

.play-volume {
  display: inline-block;
  position: relative;
  margin-left: 13px;
  vertical-align: middle;
  height: 20px;
}

.play-volume-icon {
  display: inline-block;
  width: 20px;
  height: 20px;
  background: url("/static/vedio/video_volume_icon.png") no-repeat center center;
  -webkit-background-size: cover;
  background-size: cover;
  cursor: pointer;
}

.play-volume-icon.play-volume-icon-mute {
  background: url("/static/vedio/video_volume_off_icon.png") no-repeat center
    center;
  -webkit-background-size: cover;
  background-size: cover;
}

.play-volume-list {
  position: absolute;
  bottom: 30px;
  left: -3px;
  width: 25px;
  height: 90px;
  background: rgba(0, 0, 0, 0.5);
  z-index: 222;
  /* transform: rotate(180deg); */
  display: none;
}
.play-volume-list .volume {
  right: 0.08rem;
  bottom: -0.15rem;
}
.el-slider__runway {
  background: rgba(255, 255, 255, 1);
}
.play-volume:hover .play-volume-list {
  display: block;
}

.play-volume:hover:before {
  content: "";
  display: block;
  bottom: 0.22rem;
  left: -0.12rem;
  right: 0;
  height: 0.5rem;
  position: absolute;
  cursor: pointer;
}

.play-volume-list li {
  height: 10px;
  cursor: pointer;
}

.play-volume-list li div {
  height: 5px;
  background-color: rgb(98, 98, 98);
}

.play-volume-list li.active div {
  background-color: rgb(0, 96, 255);
}

.play-fullscreen {
  display: inline-block;
  width: 20px;
  height: 20px;
  background: url("/static/vedio/video_full_screen_icon.png") no-repeat center
    center;
  -webkit-background-size: cover;
  background-size: cover;
  margin-left: 20px;
  cursor: pointer;
  vertical-align: middle;
}
</style>
<style>
.video-player .process-bar .el-slider__runway {
  margin: 0;
  height: 4px;
  padding: 10px 0;
  background-color: transparent;
  position: absolute;
  top: -10px;
  left: 0;
}
.play-volume-list .el-slider__runway {
  background: rgba(255, 255, 255, 0.29);
}
.video-player .el-slider__button {
  width: 16px;
  height: 16px;
  background: #2026cc;
  border: none;
  margin-right: 3px;
}
.video-player .process-bar .el-slider__button {
  transition: transform 0.1s cubic-bezier(0.4, 0, 1, 1);
  -webkit-transition: transform 0.1s cubic-bezier(0.4, 0, 1, 1);
  -moz-transition: transform 0.1s cubic-bezier(0.4, 0, 1, 1);
  -ms-transition: transform 0.1s cubic-bezier(0.4, 0, 1, 1);
  -o-transition: transform 0.1s cubic-bezier(0.4, 0, 1, 1);
  transform: scale(0);
  -webkit-transform: scale(0);
  -moz-transform: scale(0);
  -ms-transform: scale(0);
  -o-transform: scale(0);
}
.video-player .play-volume-list .el-slider__button {
  width: 13px;
  height: 13px;
  background: #fff;
  border: none;
  margin-right: 3px;
}
.video-player .process-bar:hover .el-slider__button {
  transform: none;
  -webkit-transform: none;
  -moz-transform: none;
  -ms-transform: none;
  -o-transform: none;
  transition: transform 0.1s cubic-bezier(0, 0, 0.2, 1);
  -webkit-transition: transform 0.1s cubic-bezier(0, 0, 0.2, 1);
  -moz-transition: transform 0.1s cubic-bezier(0, 0, 0.2, 1);
  -ms-transition: transform 0.1s cubic-bezier(0, 0, 0.2, 1);
  -o-transition: transform 0.1s cubic-bezier(0, 0, 0.2, 1);
}

.video-player .volume:hover .el-slider__button {
  transform: none;
  -webkit-transform: none;
  -moz-transform: none;
  -ms-transform: none;
  -o-transform: none;
  transition: transform 0.1s cubic-bezier(0, 0, 0.2, 1);
  -webkit-transition: transform 0.1s cubic-bezier(0, 0, 0.2, 1);
  -moz-transition: transform 0.1s cubic-bezier(0, 0, 0.2, 1);
  -ms-transition: transform 0.1s cubic-bezier(0, 0, 0.2, 1);
  -o-transition: transform 0.1s cubic-bezier(0, 0, 0.2, 1);
}

.video-player .el-slider__bar {
  height: 4px;
  background-color: #2026cc;
  border-radius: 0;
}
.video-player .play-volume-list .el-slider__bar {
  height: 4px;
  background-color: #fff;
}
.vjs-error .vjs-error-display:before {
  color: transparent !important;
}
.vjs-poster {
  background-size: cover;
}
</style>



// WEBPACK FOOTER //
// src/components/video/ManaPlayer.vue